import { render, staticRenderFns } from "./AddGroupAddress.vue?vue&type=template&id=0fbfca24&scoped=true"
import script from "./AddGroupAddress.vue?vue&type=script&lang=js"
export * from "./AddGroupAddress.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/group_information.css?vue&type=style&index=0&id=0fbfca24&prod&scoped=true&lang=css&external"
import style1 from "./AddGroupAddress.vue?vue&type=style&index=1&id=0fbfca24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbfca24",
  null
  
)

export default component.exports